import SectionHeading from "@/components/base/SectionHeading";
import { synopsis } from "@/mocks/movie";

export default function Synopsis() {
  return (
    <section id="synopsis" className="w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={synopsis.image}
                alt="《岳母的诱惑》家庭餐桌场景剧照"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-5 grid grid-cols-3 gap-3">
              {synopsis.highlights.map((item) => (
                <div
                  key={item.unit}
                  className="rounded-lg bg-secondary-100 border border-secondary-200 p-3 md:p-4 text-center"
                >
                  <p className="font-heading text-xl md:text-2xl font-bold text-secondary-900">
                    {item.value}
                    <span className="text-xs font-medium ml-0.5">{item.unit}</span>
                  </p>
                  <p className="mt-1 text-[11px] md:text-xs text-secondary-700 leading-snug">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <SectionHeading
              align="left"
              eyebrow="Synopsis"
              title="影片简介：一间屋子里的三个人"
              description="这不是一部靠情节反转取胜的电影，它更像是一次对家庭关系的冷静解剖。"
            />
            <div className="mt-8 space-y-5">
              {synopsis.paragraphs.map((p) => (
                <p key={p.slice(0, 12)} className="text-sm md:text-base leading-loose text-foreground-700">
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}